import type { ClickEvent } from '@autobid/ui/types/Vue'

export function usePopoverHover() {
  const popoverHover = ref(false)
  const popoverTimeout = ref()

  const hoverPopover = (e: ClickEvent, open: boolean): void => {
    popoverHover.value = true
    if (!open && e.target.parentElement) {
      e.target.parentElement.click()
    }
  }

  const closePopover = (close: () => void) => {
    popoverHover.value = false
    if (popoverTimeout.value)
      clearTimeout(popoverTimeout.value)
    popoverTimeout.value = setTimeout(() => {
      if (!popoverHover.value) {
        close()
      }
    }, 100)
  }

  const clickPopover = (e: ClickEvent, open: boolean) => {
    // prevent strange behavior when a user hover and click right away
    if (open) {
      e.preventDefault()
    }
  }

  return { hoverPopover, closePopover, clickPopover, popoverHover }
}
